export default __webpack_public_path__ + "static/blob6-0a72f02e7ca1cb1795c727ca2d7a1f2a.svg";